import React, { type ComponentPropsWithoutRef, useState } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { OptionHorizontalIcon } from '@/icons';
import { Drawer, DrawerContent, DrawerTitle, DrawerTrigger, IconButton } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
export const EditToolsDrawer = ({
  disabled,
  onOpen,
  tools
}: {
  disabled?: boolean;
  /** drawer 가 열릴 때 1회. 모바일 진입 계측이 데스크톱 드롭다운과 갈라지지 않게 한다. */
  onOpen?: () => void;
  tools: {
    icon: React.ReactNode;
    label: string;
    onClick: () => void;
    /** 비활성 항목은 숨기지 않고 흐리게 둔다 — 왜 못 쓰는지는 description 으로 알린다. */
    disabled?: boolean;
    description?: string;
  }[];
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <Drawer open={isOpen} onOpenChange={open => {
    setIsOpen(open);
    if (open) onOpen?.();
  }} dismissible data-sentry-element="Drawer" data-sentry-component="EditToolsDrawer" data-sentry-source-file="EditToolsDrawer.tsx">
      <DrawerTrigger asChild disabled={disabled} data-sentry-element="DrawerTrigger" data-sentry-source-file="EditToolsDrawer.tsx">
        <IconButton size="xs" variant="outlined" intent="neutral" className="flex mobile-lg:hidden" data-sentry-element="IconButton" data-sentry-source-file="EditToolsDrawer.tsx">
          <OptionHorizontalIcon size="xs" fill={disabled ? ICON_COLOR.disabled : ICON_COLOR.default} data-sentry-element="OptionHorizontalIcon" data-sentry-source-file="EditToolsDrawer.tsx" />
        </IconButton>
      </DrawerTrigger>
      <DrawerContent className="w-full px-md pb-lg" hasDrawerHandle onDimClick={() => setIsOpen(false)} hasDim={true} data-sentry-element="DrawerContent" data-sentry-source-file="EditToolsDrawer.tsx">
        {/* 번역된 도구 라벨로 이름을 짓고, 항목과 중복 낭독되지 않게 hidden 으로 둔다. */}
        <DrawerTitle asChild data-sentry-element="DrawerTitle" data-sentry-source-file="EditToolsDrawer.tsx">
          <span hidden>{tools.map(tool => tool.label).join(', ')}</span>
        </DrawerTitle>
        {tools.map(tool => <EditToolsDrawerItem key={tool.label} disabled={tool.disabled} className={cn(tool.disabled && 'opacity-[0.4]')} onClick={() => {
        tool.onClick();
        setIsOpen(false);
      }}>
            {tool.icon}
            <div className="flex flex-col">
              <span>{tool.label}</span>
              {tool.description && <span className="text-body-sm text-assistive">
                  {tool.description}
                </span>}
            </div>
          </EditToolsDrawerItem>)}
      </DrawerContent>
    </Drawer>;
};
const EditToolsDrawerItem = ({
  children,
  className,
  ...props
}: ComponentPropsWithoutRef<'button'>) => {
  // div + onClick 이면 포커스도 Enter/Space 실행도 안 된다. 모바일에서 AI 작업은
  // 이 항목으로만 노출되므로 키보드·보조기기 사용자가 접근할 수 없게 된다.
  return <button type="button" className={cn('flex w-full flex-row gap-xs px-2xs py-[13.5px] text-left text-body-lg-medium cursor-pointer items-center', 'disabled:cursor-default', className)} {...props} data-sentry-component="EditToolsDrawerItem" data-sentry-source-file="EditToolsDrawer.tsx">
      {children}
    </button>;
};